jQuery(document).ready(function ($) {
  "use strict";

  $("[data-link]").on("click", function (e) {
    e.preventDefault();
    var did = $(this).data("link");
    $("div" + did).toggleClass("is-active");
  });

  // Tab functionality
  $("[data-tabs]").tabs();

  if ($(".product-image__col--right").length) {
    $(".product-image__col--right").css(
      "paddingTop",
      $(".product__title").outerHeight(),
    );
  }

  $(".product-search__form").submit(function () {
    $(this)
      .find(":input")
      .filter(function () {
        return !this.value;
      })
      .attr("disabled", "disabled");
    return true;
  });
});
